/* unplugin-vue-components disabled */import { render } from "./Drawings.vue?vue&type=template&id=09307566&scoped=true&ts=true"
import script from "./Drawings.vue?vue&type=script&lang=ts"
export * from "./Drawings.vue?vue&type=script&lang=ts"

import "./Drawings.vue?vue&type=style&index=0&id=09307566&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09307566"]])

export default __exports__